module.exports = __webpack_public_path__ + "img/roulette-spades-large.97b170a6.svg";